/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
import type { ServerError, ServerParseError } from "@apollo/client";
import { ApolloError } from "@apollo/client";

export function getNetworkError(error?: ApolloError | Error | null) {
  if (error instanceof ApolloError) {
    return error.networkError;
  }
  return null;
}
export function getGraphQLError(error?: ApolloError | Error | null) {
  if (error instanceof ApolloError) {
    return error.graphQLErrors.length > 0 ? error.graphQLErrors[0] : null;
  }
  return null;
}
export function isApolloServerError<E extends ApolloError>(
  error: E | Error | ServerParseError | ServerError | null,
): error is ServerError {
  return (
    error !== null &&
    error.name === "ServerError" &&
    (error as ServerError).response instanceof Response &&
    (error as ServerError).result !== null
  );
}
